import React from "react";
import styled from "styled-components";

const MainBlock = styled.div`
    padding:10px;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 6px;
    margin-bottom: 8px;

    & .title-block{
        font-weight: bold;
        font-size: 18px;
        padding: 5px 0px;
        color: #003E8D;
    }
    & .benefits-block{
        padding: 0px 0px 10px 12px;
    }
    /* & .desc-block{
        padding: 0px 0px 10px 25px;
    } */
`;

const CardBenefits = (props) => {
  const { CardData } = props;
  return (
    <React.Fragment>
      {CardData.map((data, index) => {
        return (
          <MainBlock key={index}>
            <div className="title-block">{data.CardBenefitTitle.replace(/u2019/g,"'")}</div>
            <div className="benefits-block">{data.CardBenefitDescription.replace(/u2019/g,"'")}</div>
            {/* <div className="desc-block">{data.Benefit.replace(/u2019/g,"'")}</div> */}
          </MainBlock>
        );
      })}
      {/* <img src={getImg(item.image.split("#image#")[1])} alt="image not found" width="120px" height="90px" onClick={()=>{props.overlayImageModalToggle("#ImagePath#"+"#RBLIMG#"+getImg(item.image.split("#image#")[1]))}} /> */}
    </React.Fragment>
  );
};
export default CardBenefits;